/** Shared list parsing for legacy KYC fetchByStatus responses. */

function extractArrayFromPayload(payload: unknown): unknown[] | null {
  if (payload == null) return null;
  if (Array.isArray(payload)) return payload;
  if (typeof payload !== 'object') return null;

  const o = payload as Record<string, unknown>;

  if (o.success === false) return null;
  if (typeof o.statusCode === 'number' && o.statusCode >= 400) return null;

  const data = o.data;
  if (Array.isArray(data)) return data;
  if (data && typeof data === 'object') {
    const inner = data as Record<string, unknown>;
    if (Array.isArray(inner.data)) return inner.data;
    if (Array.isArray(inner.items)) return inner.items;
    if (Array.isArray(inner.rows)) return inner.rows;
  }

  if (Array.isArray(o.items)) return o.items;
  if (Array.isArray(o.rows)) return o.rows;

  return null;
}

export function parseKycListResponse(response: { data?: unknown }): Record<string, unknown>[] {
  const list =
    extractArrayFromPayload(response?.data) ?? extractArrayFromPayload(response);
  return (list ?? []) as Record<string, unknown>[];
}
